import * as d3 from "d3";

const legendDiv = document.getElementById("legend");
// add predefined legend width due to chrome clientWidth bug
const legendWidth = legendDiv.clientWidth;
const legend = d3
  .select(legendDiv)
  .append("svg")
  .style("width", legendWidth + "px");
const legendMargin = { top: 10, right: 10, bottom: 10, left: 10 };

export function drawLegend(d3Data, d3Scales, analysisType) {
  let legendWidth =
    +legendDiv.clientWidth - legendMargin.left - legendMargin.right;
  let legendHeight =
    +legendDiv.clientHeight - legendMargin.top - legendMargin.bottom;

  //scale the svg to the area
  legend
    .attr("width", legendWidth + legendMargin.left + legendMargin.right)
    .attr("height", legendHeight + legendMargin.top + legendMargin.bottom);

  //clear the slate
  legend.selectAll("*").remove();

  var legendgroup = legend
    .append("g")
    .attr("font-family", "Helvetica, Arial, sans-serif;")
    .attr("font-size", 12)
    .attr("text-anchor", "end")
    .selectAll("g")
    .data(d3Data.keys.slice())
    .enter()
    .append("g")
    .attr("transform", function(d, i) {
      if (d3Data.keys.length == 1) {
        return "translate(1," + 25 + ")";
      } else if (d3Data.keys.length == 2) {
        return "translate(1," + (i * 25 + 13) + ")";
      } else {
        return "translate(1," + i * 25 + ")";
      }
    });

  legendgroup
    .append("rect")
    .attr("x", legendWidth - 25)
    .attr("y", legendHeight / 14)
    .attr("width", 20)
    .attr("height", 20)
    .attr("fill", d3Scales.z);

  legendgroup
    .append("text")
    .attr("x", legendWidth - 30)
    .attr("y", legendHeight / 14 + 10)
    .attr("dy", "0.32em")
    .text(function(d) {
      if (analysisType === "earnings-percentile") {
        if (d === 1) {
          return d + " Year Postgrad";
        } else {
          return d + " Years Postgrad";
        }
      } else {
        return d + "th Percentile";
      }
    });
}

export function clearLegend() {
  legend.selectAll("*").remove();
}
